<template>
  <div>
    <el-container
      style="height: 100vh;">
      <el-aside
        width="100%"
        style="background-color: rgb(238, 241, 246); border-right: 1px #eee solid;">
        <el-menu
          :default-openeds="['1']">
          <router-link to="/admin">
            <el-menu-item>{{ handleCommon('menu.home') }}</el-menu-item>
          </router-link>
          <router-link to="/admin/contact">
            <el-menu-item index="1-1">{{ handleCommon('menu.contact') }}</el-menu-item>
          </router-link>
        </el-menu>
      </el-aside>
    </el-container>
  </div>
</template>

<script>
import common from '@/utils/common'

export default {
  methods: {
    handleCommon(k) {
      return k.split('.').reduce((a, c) => a[c], common)
    }
  }
}
</script>
